export enum ColorPickerSourceType {
    GRADIENT = 'GRADIENT',
    HUE = 'HUE',
    SWATCH = 'SWATCH'
}
